import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterPlattekloof() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-plattekloof",
    name: "Painters Plattekloof",
    location: "Plattekloof, Cape Town",
    rating: 4.8,
    reviews: 149,
    specialties: ["Residential Painting", "Commercial Painting", "Roof Coating", "Damp Proofing"],
    image: "https://public.readdy.ai/ai/img_res/b0d5cf315526952db8605f54013b54a0.jpg",
    verified: true,
    yearsExperience: 14,
    website: "https://paintersplattekloof.co.za/",
    email: "info@paintersplattekloof.co.za",
    description: "Painters Plattekloof is your trusted local painting contractor serving Plattekloof and the Northern Suburbs of Cape Town. With 14 years of experience, we specialize in residential and commercial painting projects, offering comprehensive services from interior and exterior painting to roof coating and damp proofing. Our experienced team delivers high-quality workmanship with attention to detail, using premium paints and materials. We pride ourselves on professionalism, reliability, and customer satisfaction.",
    services: [
      "Interior House Painting",
      "Exterior House Painting",
      "Roof Painting & Coating",
      "Commercial Painting",
      "Damp Proofing Solutions",
      "Waterproofing Services",
      "Wall Preparation & Repairs",
      "Color Consultation",
      "Maintenance Services",
      "Protective Coatings"
    ],
    serviceAreas: ["Plattekloof", "Panorama", "Welgemoed", "Bellville", "Parow", "Durbanville", "Monte Vista"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20modern%20living%20room%20interior%20painted%20by%20professional%20painters%20in%20Plattekloof%20Cape%20Town%2C%20contemporary%20family%20home%20with%20fresh%20white%20walls%2C%20quality%20paint%20finish%2C%20comfortable%20furniture%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work&width=400&height=300&seq=plattekloof-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20Plattekloof%20Cape%20Town%2C%20northern%20suburbs%20family%20home%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20suburban%20setting%20with%20mountain%20backdrop%2C%20well-maintained%20property&width=400&height=300&seq=plattekloof-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Roof%20painting%20and%20coating%20project%20in%20Plattekloof%20Cape%20Town%2C%20professional%20painters%20working%20on%20residential%20roof%2C%20quality%20roof%20coating%20application%2C%20suburban%20home%2C%20organized%20work%20site&width=400&height=300&seq=plattekloof-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20interior%20painting%20in%20Plattekloof%20home%2C%20fresh%20painted%20walls%20with%20premium%20finish%2C%20contemporary%20kitchen%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=plattekloof-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Commercial%20building%20exterior%20painting%20in%20Plattekloof%20Cape%20Town%2C%20professional%20painters%20working%20on%20business%20property%2C%20quality%20commercial%20paint%20finish%2C%20modern%20architecture%2C%20organized%20professional%20work%20site&width=400&height=300&seq=plattekloof-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bedroom%20interior%20painting%20in%20Plattekloof%20family%20home%2C%20fresh%20painted%20walls%20with%20quality%20finish%2C%20comfortable%20bedroom%20design%2C%20bright%20natural%20lighting%2C%20professional%20painting%20work&width=400&height=300&seq=plattekloof-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Mark Johnson",
        rating: 5,
        comment: "Excellent service from Painters Plattekloof! They painted our entire home including roof coating and the results are outstanding. Professional team, great communication, and completed on time. Highly recommend!"
      },
      {
        name: "Susan Botha", 
        rating: 5,
        comment: "Very impressed with the quality of work. They handled our damp proofing and painting project expertly. Clean workers, reasonable pricing, and the finish is perfect. Will definitely use them again."
      },
      {
        name: "Peter van der Walt",
        rating: 4,
        comment: "Great attention to detail and very professional. Our Plattekloof home looks brand new after their work. Good value for money and reliable service."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Plattekloof | Professional Painting Services Cape Town | Residential & Commercial Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Plattekloof offers professional painting services for residential and commercial properties in Plattekloof, Cape Town. Specializing in interior, exterior, roof coating, and damp proofing. 14+ years experience. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Plattekloof, house painters Plattekloof, painting contractors Cape Town, residential painting, roof coating services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20family%20home%20in%20Plattekloof%20Cape%20Town%2C%20northern%20suburbs%20residential%20neighborhood%20with%20stunning%20mountain%20views%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20modern%20suburban%20architecture%2C%20bright%20natural%20lighting%2C%20high%20quality%20residential%20painting%20project&width=1200&height=600&seq=plattekloof-painters-hero-main&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Plattekloof</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Northern Suburbs Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Plattekloof is a well-established residential area in Cape Town's Northern Suburbs, known for its family homes and quality properties. Our team has extensive experience working throughout this area, understanding the specific needs of local homeowners and businesses. We've built our reputation on delivering reliable, high-quality painting services that enhance property value and curb appeal.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Painting Solutions</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  From interior refreshes to complete exterior transformations, we offer comprehensive painting solutions for all types of properties. Our services include standard painting work as well as specialized services like roof coating, damp proofing, and waterproofing. We use only premium paints and materials, ensuring durability and beautiful finishes that stand the test of time.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality & Professionalism</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our team consists of skilled, experienced painters who take pride in their work. We maintain high standards of professionalism, from the initial consultation through project completion. Our painters are courteous, punctual, and respectful of your property. We ensure thorough surface preparation, precise application, and complete cleanup, leaving your property looking immaculate.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Customer Satisfaction Guarantee</h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  We stand behind our work with solid guarantees and excellent customer support. Our goal is complete customer satisfaction, and we're not finished until you're delighted with the results. We offer free consultations and detailed quotes, transparent pricing, and clear communication throughout your project. Many of our clients are repeat customers or referrals, testament to the quality of our work and service.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20residential%20home%20in%20Plattekloof%20Cape%20Town%2C%20northern%20suburbs%20property%20with%20quality%20paint%20finish%2C%20painters%20in%20uniform%20with%20professional%20equipment%2C%20modern%20suburban%20architecture%2C%20organized%20work%20site&width=400&height=300&seq=plattekloof-sidebar-image&orientation=landscape"
                      alt="Professional painters Plattekloof residential house painting services Cape Town northern suburbs"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Plattekloof</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Residential & Commercial Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services cover all aspects of residential and commercial projects in Plattekloof and the Northern Suburbs. From single rooms to entire properties, we provide comprehensive solutions that enhance aesthetics and protect your investment.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} with premium materials and expert application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Services</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Transform your Plattekloof home with our professional interior painting services. We use premium, low-VOC paints that are safe for your family while providing excellent coverage and durability. Our color consultation services help you choose the perfect palette that complements your home's style and enhances natural light.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We take care to protect your furniture and flooring, work cleanly, and complete projects efficiently. Whether you're refreshing a single room or painting your entire home, we deliver exceptional results with minimal disruption to your daily routine.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Painting & Protection</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting enhances curb appeal and protects your property from the elements. We use premium exterior paints that resist fading, weathering, and moisture damage. Our comprehensive exterior painting process includes thorough surface preparation, repairs as needed, primer application, and multiple coats for maximum protection and beauty.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We also specialize in roof coating, which not only improves appearance but provides additional protection and can help reduce energy costs. Our damp proofing and waterproofing services address moisture issues, protecting your property's structural integrity.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Plattekloof</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Plattekloof and the Northern Suburbs. Each project demonstrates our commitment to quality workmanship and professional service.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Plattekloof Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Plattekloof have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Plattekloof</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Plattekloof property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and Northern Suburbs</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Plattekloof painting project. Our experienced team will assess your property and provide detailed recommendations.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
